import { apiGet, apiPut } from "../apiClient";

export interface AnnouncementSettings {
  isActive: boolean;
  startDate: string | null;
  endDate: string | null;
  title: { eng: string; fr: string };
  message: { eng: string; fr: string };
  style: "info" | "warning" | "success";
  ctaText: { eng: string; fr: string } | null;
  ctaLink: string | null;
}

export interface AnnouncementResponse {
  success: boolean;
  data: {
    announcement: AnnouncementSettings & { isEffectivelyActive: boolean };
  };
}

export interface PublicAnnouncementResponse {
  success: boolean;
  data: {
    title: { eng: string; fr: string };
    message: { eng: string; fr: string };
    style: "info" | "warning" | "success";
    ctaText: { eng: string; fr: string } | null;
    ctaLink: string | null;
  } | null;
}

export const getSiteConfig = () =>
  apiGet<AnnouncementResponse>("/api/admins/site-config");

export const updateAnnouncement = (announcement: AnnouncementSettings) =>
  apiPut<AnnouncementResponse>("/api/admins/site-config/announcement", { announcement });

export const getPublicAnnouncement = () =>
  apiGet<PublicAnnouncementResponse>("/api/public/announcement");
